var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[(_vm.showError)?_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_vm._v("Betalningen misslyckades")]):_vm._e(),(_vm.showSuccess)?_c('b-alert',{attrs:{"show":"","variant":"success"}},[_vm._v("Betalningen lyckades")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }